<template>
  <div :class="$style.layout">
    <Header isUser />

    <div :class="$style.main" id="user-page">
      <div :class="$style.left">
        <UserNav />
      </div>

      <div :class="$style.right">
        <router-view></router-view>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";
import UserNav from "./UserNav.vue";

export default {
  name: "User",
  components: {
    Header,
    Footer,
    UserNav,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("login", ["isLogin"]),
  },
  methods: {},
  mounted() {
    document.querySelector("#user-page").scrollIntoView();
  },
};
</script>

<style lang="scss" module scoped>
.layout {
  .main {
    min-width: 1280px;
    min-height: calc(100vh - rem(80));
    padding-top: rem(80);
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .left {
      width: rem(300);
    }

    .right {
      box-sizing: border-box;
      width: rem(1620);
      padding: rem(60);
    }
  }
}
</style>